import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IPage, IPageSize, TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	isEnabled: boolean | null;
	role: string | null;
	organizationId?: string;
}

const initialState: IInitialState = {
	...defaultMeta,
	searchValue: '',
	isEnabled: null,
	role: null,
	sortDirection: false,
	sortFieldName: null,
	organizationId: undefined,
};

const users = createSlice({
	name: 'users',
	initialState,
	reducers: {
		setPage: (state, action: PayloadAction<IPage>) => {
			state.page = action.payload.page;
		},
		setPageSize: (state, action: PayloadAction<IPageSize>) => {
			state.pageSize = action.payload.pageSize;
			state.page = initialState.page;
		},
		setSort: (state, action: PayloadAction<{
			sortDirection: boolean | null;
			sortFieldName: string | null;
		}>) => {
			state.sortDirection = action.payload.sortDirection;
			state.sortFieldName = action.payload.sortFieldName;
		},
		setSearchValue: (state, action: PayloadAction<{ searchValue: string }>) => {
			state.searchValue = action.payload.searchValue;
			state.page = initialState.page;
		},
		setIsEnabled: (state, action: PayloadAction<{ isEnabled: boolean | null }>) => {
			state.isEnabled = action.payload.isEnabled;
			state.page = initialState.page;
		},
		setRole: (state, action: PayloadAction<{ role: string | null }>) => {
			state.role = action.payload.role;
			state.page = initialState.page;
		},
		setOrganizationId: (state, action: PayloadAction<{ organizationId?: string }>) => {
			return {
				...initialState,
				organizationId: action.payload.organizationId,
			};
		},
		resetUsersTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setIsEnabled,
	setRole,
	resetUsersTable,
	setOrganizationId,
} = users.actions;

export default users.reducer;
